import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "./Employee.css";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { FaEdit } from "react-icons/fa";
import { FaList } from "react-icons/fa6";
import { HiUserRemove } from "react-icons/hi";
import { UseGeneratePDF } from "./UseGeneratePDF";
import {
  getDesignation,
  getRoleList,
  getEmployeeList,
  getEmployeeDataForExcel,
  getUserByLoginId,
  validateUser,
  createUser,
  getPersonalDetails,
  getFamilyDetails,
  getEducationDetails,
  getExperienceDetails,
  getUserDocumentDetails,
  markEmployeeExit,
} from "../../Redux/NewHire/Action";
import { useNavigate } from "react-router-dom";
import "jspdf-autotable";
import { EMP_USER_DETAILS } from "../../Redux/NewHire/ActionType";
import { fetchClientDetails } from "../../Redux/Config/Action";
import NewGlobalDataTable from "../DataTable/NewGlobalDataTable";
import Icon from "../utility/Icon";
import * as XLSX from "xlsx";
import { autoFitColumns, prepareExcelData } from "../utility/excelUtils";
import { FaFileExcel } from "react-icons/fa";
import { empList } from "../../Redux/DailyUpdateApproval/Action";
import Select from 'react-select';


const EmployeeDetails = () => {
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    desiglist,
    rolelists,
    validationStatus,
    statusDesc,
    field,
    empUserDetails,
    employeelist,
    personalDetails,
    familyListDetails,
    educationListDetails,
    experienceListDetails,
    userdocslist,
    employeeDataExcel,
  } = useSelector((store) => store.newHireData);
  const { emplists } = useSelector((store) => store.dailyUpdateApprover);

  const [show, setShow] = useState(false);
  const [exitModal, setExitModal] = useState(false);
  const [emailValidationMessage, setEmailValidationMessage] = useState("");
  const [panValidationMessage, setPanValidationMessage] = useState("");
  const [submitEnabled, setSubmitEnabled] = useState(false);
  const [generatePdfFlag, setGeneratePdfFlag] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(1);
  const [searchText, setSearchText] = useState("");
  const { clientDetails } = useSelector((store) => store.config);
  const { generatePDF } = UseGeneratePDF();
  const [userdesignation, setUserdesignation] = useState("");
  const roles = ["ROLE_CANDIDATE", "ROLE_EXIT"];


  useEffect(() => {
    dispatch(getDesignation(token));
    dispatch(getRoleList(token));
  }, [dispatch, token]);

  useEffect(() => {
    dispatch(getEmployeeList(token, pageNumber - 1, pageSize, searchText));
  }, [dispatch, token, pageNumber, pageSize, searchText]);

  const [formData, setFormData] = useState({
    userId: "",
    firstName: "",
    lastName: "",
    personalEmail: "",
    dateOfBirth: "",
    pan: "",
    role: "",
    designation: "",
    managerId: "",
    hrId: "",
    actionType: "",
  });

  const [exitFormData, setExitFormData] = useState({
    userId: "",
    exitDate: "",
    firstName: "",
  })

  const handleClose = () => {
    clearUserInputFields();
    setShow(false);
  };

  const handleEditUser = (row) => {
    dispatch(getUserByLoginId(row.loginId, token, EMP_USER_DETAILS));
    dispatch(empList(token, "EMP"));

    setShow(true);
  };

  const hireDetails = (row) => {
    navigate("/newHireDetails", { state: { rowData: row } });
  };

  useEffect(() => {
    if (empUserDetails) {
      const matchedRole = rolelists.find(
        (role) => role.roleName === empUserDetails.role
      );
      setFormData({
        userId: empUserDetails.loginId || "",
        firstName: empUserDetails.firstName || "",
        lastName: empUserDetails.lastName || "",
        personalEmail: empUserDetails.personalEmail || "",
        dateOfBirth: empUserDetails.dob || "",
        pan: empUserDetails.pan || "",
        role: matchedRole ? matchedRole.roleId : "",
        designation: empUserDetails.designationId
          ? empUserDetails.designationId
          : "",
        managerId: empUserDetails.managerId
          ? empUserDetails.managerId
          : "",
        hrId: empUserDetails.hrId
          ? empUserDetails.hrId
          : "",
        actionType: "UPDATE",
      });
    }
  }, [empUserDetails, rolelists]);

  useEffect(() => {
    if (formData.actionType === "UPDATE") {
      setSubmitEnabled(true);
    }
    if (field === "personalEmail") {
      if (validationStatus === "99") {
        setEmailValidationMessage(statusDesc);
        setSubmitEnabled(false);
      } else if (validationStatus === "00") {
        setEmailValidationMessage("");
        setSubmitEnabled(true);
      }
    }
    if (field === "pan") {
      if (validationStatus === "99") {
        setPanValidationMessage(statusDesc);
        setSubmitEnabled(false);
      } else if (validationStatus === "00") {
        setPanValidationMessage("");
        setSubmitEnabled(true);
      }
    }
  }, [validationStatus, statusDesc, field, formData.actionType]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (value && /^[\s]/.test(value)) {
      e.preventDefault();
      return;
    }
    if (
      (name === "firstName" || name === "lastName") &&
      /[^a-zA-Z\s]/.test(value)
    ) {
      e.preventDefault();
      return;
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "pan" ? value.toUpperCase() : value,
    }));

    if (name === "personalEmail" || name === "pan") {
      dispatch(validateUser({ ...formData, [name]: value }, name, token));
    }
  };

  const handleDateChange = (date, name) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: date ? format(date, "yyyy-MM-dd") : "",
    }));
  };
  const handleExitEmpDateChange = (date, name) => {
    setExitFormData((prevData) => ({
      ...prevData,
      [name]: date ? format(date, "yyyy-MM-dd") : "",
    }));
  };

  const clearUserInputFields = () => {
    setFormData([
      {
        userId: "",
        firstName: "",
        lastName: "",
        personalEmail: "",
        dateOfBirth: "",
        pan: "",
        role: "",
        designation: "",
        managerId: "",
        hrId: "",
        actionType: "",
      },
    ]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.role || !formData.designation || !formData.managerId || !formData.hrId) {
      Swal.fire({
        icon: "warning",
        title: "Warning",
        text: "Please fill all the required fields.",
        timer: 2000,
      });
      return;
    }
    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      dispatch(createUser(formData, token))
        .then(({ response }) => {
          if (response.statusMessage === "SUCCESS") {
            dispatch(getEmployeeList(token, pageNumber - 1, pageSize));
            setShow(false);
            Swal.fire({
              title: "Success!",
              text: "User details submitted successfully.",
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "User details submitted unsuccessfull",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch(() => {
          Swal.fire({
            title: "Error!",
            text: "There was an error submitting the user details.",
            icon: "error",
            confirmButtonText: "OK",
          });
        });
    }
  };


  const handleExitEmployeeSubmit = async (e) => {
    e.preventDefault();
    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, submit it!",
      cancelButtonText: "No, cancel",
    });
    if (result.isConfirmed) {
      dispatch(markEmployeeExit(exitFormData, token))
        .then((result) => {
          if (result.success) {
            dispatch(getEmployeeList(token, pageNumber - 1, pageSize));
            setExitModal(false);
            Swal.fire({
              title: "Success!",
              text: "User marked as deactivated successfully.",
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: result.error || "User marked as deactivated unsuccessfull",
              icon: "error",
              confirmButtonText: "OK",
            });
          }
        })
        .catch((err) => {
          console.error(err);
          Swal.fire({
            title: "Error!",
            text: "There was an error submitting the user details.",
            icon: "error",
            confirmButtonText: "OK",
          });
        });

    }
  };

  const handleViewClick = async (row) => {
    const designation = desiglist.find(
      (desig) => desig.designationId === row.designationId
    );

    if (designation) setUserdesignation(designation.designationName);
    await Promise.all([
      dispatch(getUserByLoginId(row.loginId, token, EMP_USER_DETAILS)),
      dispatch(getPersonalDetails(row.loginId, token)),
      dispatch(getFamilyDetails(row.loginId, token)),
      dispatch(getEducationDetails(row.loginId, token)),
      dispatch(getExperienceDetails(row.loginId, token)),
      dispatch(getUserDocumentDetails(row.loginId, token)),
      dispatch(fetchClientDetails(token)),
    ]);
    setGeneratePdfFlag(true);
  };

  const handleExitEmpclick = (row) => {
    setExitFormData({
      userId: row.loginId,
      firstName: row.firstName + " " + row.lastName,
    })
    setExitModal(true);
  }

  useEffect(() => {
    if (generatePdfFlag) {
      if (
        empUserDetails &&
        personalDetails &&
        familyListDetails &&
        educationListDetails &&
        experienceListDetails &&
        clientDetails
      ) {
        generatePDF(
          empUserDetails,
          personalDetails,
          familyListDetails,
          educationListDetails,
          experienceListDetails,
          clientDetails,
          userdesignation,
          userdocslist,
        );
        setGeneratePdfFlag(false);
      }
    }
  }, [
    empUserDetails,
    personalDetails,
    familyListDetails,
    educationListDetails,
    experienceListDetails,
    clientDetails,
    generatePdfFlag,
    generatePDF,
  ]);

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const Tooltip = ({ text, children }) => {
    return (
      <div className="tooltip-container">
        {children}
        <div className="tooltip">{text}</div>
      </div>
    );
  };

  const columns = [
    {
      name: "EmpId",
      selector: (row) => row.empId?.trim() || "-",
      sortable: true,
    },
    {
      name: "DOJ",
      selector: (row) => formatDate(row.joiningDate),
      sortable: true,
      isDate: true,
    },
    {
      name: "Name",
      selector: (row) => `${row.firstName?.trim() || ""} ${row.lastName?.trim() || ""}`.trim() || "-",
      sortable: true,
    },
    {
      name: "DOB",
      selector: (row) => formatDate(row.dob),
      sortable: true,
      isDate: true,
    },
    {
      name: "Mobile Number",
      selector: (row) => row?.mobileNumber || "-",
      sortable: true,
      align: "center",
    },
    {
      name: " Username",
      selector: (row) => row.username?.trim() || "-",
      sortable: true,
    },
    {
      name: "Personal Email",
      selector: (row) => row.personalEmail?.trim() || "-",
      sortable: true,
    },

    {
      name: "Designation",
      selector: (row) => {
        const designation = desiglist.find(
          (desig) => desig.designationId === row.designationId
        );
        return designation?.designationName || "Unknown";
      },
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => row,
      sortable: false,
      width: "226px",
      cell: (row) => (
        <div>

          <Tooltip text="Edit">
            <Icon
              icon={FaEdit}
              variant="warning"
              className="me-3"
              onClick={() => handleEditUser(row)}
            />
          </Tooltip>
          <Tooltip text="Personal Info">
            <Icon
              icon={FaList}
              variant="secondary"
              className="cs-btn-personal me-3"
              onClick={() => hireDetails(row)}
            />
          </Tooltip>
          <Tooltip text="Deactivate Employee">
            <Icon
              icon={HiUserRemove}
              variant="danger"
              onClick={() => handleExitEmpclick(row)}
            />
          </Tooltip>

        </div>
      ),
    },
  ];

  const designationMap = React.useMemo(() => {
    const map = {};
    desiglist?.forEach(d => {
      map[d.designationId] = d.designationName;
    });
    return map;
  }, [desiglist]);


  const excelColumns = [
    { header: "S.No", key: "sn" },
    { header: "EmpId", key: "empId" },
    { header: "DOJ", key: "joiningDate", type: "date" },
    {
      header: "Name",
      value: (row) => [row.firstName, row.lastName].filter(Boolean).join(" ")
    },
    { header: "DOB", key: "dob", type: "date" },
    { header: "Mobile Number", key: "mobileNumber" },
    { header: "Username", key: "username" },
    { header: "Personal Email", key: "personalEmail" },
    { header: "PAN", key: "pan" },
    {
      header: "Designation",
      value: row => designationMap[row.designationId] || ""
    }
  ];

  const downloadExcel = () => {
    dispatch(getEmployeeDataForExcel(token));
  };

  useEffect(() => {
    if (employeeDataExcel?.userList?.length > 0) {

      const excelData = prepareExcelData(employeeDataExcel.userList, excelColumns);

      const ws = XLSX.utils.json_to_sheet(excelData);
      autoFitColumns(ws);

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "OfficeEmployees");

      XLSX.writeFile(wb, "Office Employees.xlsx");
    }
  }, [employeeDataExcel?.userList]);

  const roleOptions = rolelists.filter((role) => !roles.includes(role.roleName)).map(c => ({
    value: c.roleId,
    label: c.roleName,
  }));

  const desigOptions = desiglist.map(c => ({
    value: c.designationId,
    label: c.designationName,
  }));

  const empOptions = emplists.filter(emp => emp.firstName).map(p => ({
    value: p.loginId,
    label: `${p?.firstName || ""} ${p?.lastName || ""}`.trim(),
  }));


  return (
    <div>
      <Navbar></Navbar>
      <div className="main-content">
        <div className="container-fluid mt-4">

          <div className="row mb-3 justify-content-end align-items-center">
            <div className="col-auto d-flex align-items-center">
              {employeelist?.userList && employeelist?.userList.length > 0 &&
                <button className="btn btn-sm btn-success me-2" onClick={downloadExcel}>
                  DOWNLOAD EXCEL
                </button>
              }
            </div>
          </div>

          <NewGlobalDataTable
            columns={columns}
            data={employeelist.userList}
            tableName={'EMPLOYEES'}
            setPageSize={setPageSize}
            setFilterText={setSearchText}
            totalRecord={employeelist.totalRecord}
            setPageNumber={setPageNumber} />

        </div>
      </div>
      {
        show && (
          <>
            <div className="modal-backdrop fade show"></div>
            <div
              className="modal fade employee-modal show"
              tabIndex="-1"
              role="dialog"
              style={{ display: "block" }}
            >
              <div
                className="modal-dialog modal-lg modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {formData.actionType === "INSERT"
                        ? "Create User"
                        : "Edit User"}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={handleClose}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-1">
                            <label className="form-label">
                              <b>First Name</b>
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              required
                              maxLength="100"
                              name="firstName"
                              value={formData.firstName || ""}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                        <div className=" col-md-6">
                          <div className="mb-1">
                            <label className="form-label">
                              <b>Last Name</b>
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              required
                              maxLength="100"
                              name="lastName"
                              value={formData.lastName || ""}
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className=" col-md-6">
                          <div className="mb-1">
                            <label className="form-label">
                              <b>Email Id</b>
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="email"
                              className="form-control"
                              required
                              maxLength="100"
                              name="personalEmail"
                              value={formData.personalEmail || ""}
                              onChange={handleChange}
                            />
                            {emailValidationMessage && (
                              <div className="text-danger">
                                {emailValidationMessage}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className=" col-md-6">
                          <div className="mb-1">
                            <label className="form-label">
                              <b>D.O.B</b>
                              <span className="text-danger">*</span>
                            </label>
                            <DatePicker
                              selected={formData.dateOfBirth ? new Date(formData.dateOfBirth) : null}
                              onChange={(date) => handleDateChange(date, "dateOfBirth")}
                              className="form-control"
                              dateFormat="dd-MM-yyyy"
                              placeholderText="Date Of Birth"
                              showYearDropdown
                              showMonthDropdown
                              dropdownMode="select"
                              onKeyDown={(event) => event.preventDefault()}
                              maxDate={new Date()}
                              required
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-1">
                            <label className="form-label">
                              <b>PAN</b>
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              required
                              maxLength="10"
                              minLength="10"
                              name="pan"
                              value={formData.pan || ""}
                              onChange={handleChange}
                              style={{ textTransform: "uppercase" }}
                            />
                            {panValidationMessage && (
                              <div className="text-danger">
                                {panValidationMessage}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="  col-md-6">
                          <div className="mb-1">
                            <label className="form-label">
                              <b>Role</b>
                              <span className="text-danger">*</span>
                            </label>
                            <Select
                              options={roleOptions}
                              value={roleOptions.find(opt => opt.value === formData.role) || null}
                              onChange={(selectedOption) =>
                                setFormData(prev => ({
                                  ...prev,
                                  role: selectedOption?.value || ""
                                }))
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="">
                            <label className="form-label">
                              <b>Designation</b>
                              <span className="text-danger">*</span>
                            </label>
                            <Select
                              options={desigOptions}
                              value={desigOptions.find(opt => opt.value === formData.designation) || null}
                              onChange={(selectedOption) =>
                                setFormData(prev => ({
                                  ...prev,
                                  designation: selectedOption?.value || ""
                                }))
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group mb-1">

                            <label
                              htmlFor="managerId"
                              className="form-label"
                              id="managerId"
                            >
                              <b>Manager</b><span className="text-danger">*</span>
                            </label>
                            <Select
                              options={empOptions}
                              value={empOptions.find(opt => opt.value === formData.managerId) || null}
                              onChange={(selectedOption) =>
                                setFormData(prev => ({
                                  ...prev,
                                  managerId: selectedOption?.value,
                                }))
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row ">
                        <div className="col-md-6">
                          <div className="form-group">

                            <label
                              htmlFor="hrId"
                              className="form-label"
                              id="hrId"
                            >
                              <b> HR</b><span className="text-danger">*</span>
                            </label>
                            <Select
                              options={empOptions}
                              value={empOptions.find(opt => opt.value === formData.hrId) || null}
                              onChange={(selectedOption) =>
                                setFormData(prev => ({
                                  ...prev,
                                  hrId: selectedOption?.value,
                                }))
                              }
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col text-center mt-3">
                          <button
                            type="submit"
                            id="sbmtdata"
                            className={`btn ${formData.actionType === "UPDATE" ? "btn-warning" : "btn-success"} `}
                            disabled={!submitEnabled}
                          >
                            {formData.actionType === "UPDATE"
                              ? "UPDATE"
                              : "SUBMIT"}
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </>
        )
      }
      {
        exitModal && (
          <>
            <div className="modal-backdrop fade show"></div>
            <div
              className="modal fade employee-modal show"
              tabIndex="-1"
              role="dialog"
              style={{ display: "block" }}
            >
              <div
                className="modal-dialog modal-md"
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Deactivate Employee</h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => setExitModal(false)}
                    ></button>
                  </div>
                  <div className="modal-body">
                    <form onSubmit={handleExitEmployeeSubmit}>
                      <div className="row">

                        <div className="col-md-4">
                          <label className="form-label fw-bold">
                            Employee Name :
                          </label>
                        </div>
                        <div className="col-md-8">
                          {exitFormData.firstName}
                        </div>

                        <div className="col-md-4">
                          <div className="mb-3">
                            <label className="form-label fw-bold">
                              Date of Deactivate
                              <span className="text-danger">*</span>
                            </label>

                          </div>
                        </div>

                        <div className="col-md-8">
                          <DatePicker
                            selected={exitFormData.exitDate}
                            onChange={(date) => handleExitEmpDateChange(date, "exitDate")}
                            className="form-control"
                            dateFormat="dd-MM-yyyy"
                            placeholderText="Date Of Deactivate"
                            showYearDropdown
                            showMonthDropdown
                            dropdownMode="select"
                            onKeyDown={(event) => event.preventDefault()}
                            required
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col text-center mt-3">
                          <button
                            type="submit"
                            id="sbmtdata"
                            className="btn btn-success"
                          >
                            SUBMIT
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </>

        )
      }
    </div >
  );
};

export default EmployeeDetails;
